import { factoryService, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_SELLER_URL } from '../config/settings/environment'

/**
 * To validate a google recaptcha token enterprise with backend service
 */
export const verifyGoogleRecaptchaToken = factoryService(({ token }) => {
  const body = {
    aplicativo: 'comprador', // comprador,, always-bot, always-human
    token
  }
  return postJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v2/recaptcha/verifyCaptcha`, { body })
})
